//NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { areResultsOwnedByUser } from 'selectors';
import Layout from 'Components/Layout/Layout';
import ResultsNavigationButton from './ResultsNavigationButton';
import ResultsShareButton from './ResultsShareButton';
import RecommendationList from './Recommendations/RecommendationList';

const REC_FILTERS = {
  isFavorite: true,
};

class ResultsFavorites extends Component {
  componentDidMount = () => {
    const { setResult, getFilteredRecommendations, resultUUID } = this.props;
    setResult(resultUUID);
    getFilteredRecommendations();
  };

  render() {
    const { areResultsOwnedByUser, resultUUID } = this.props;
    return (
      <Layout>
        <div className={`ResultsFavourites-holder`}>
          <div className="ResultsFavourites-heading">
            <ResultsNavigationButton path="index" resultUUID={resultUUID} />
            <h1>Favourites</h1>
            <ResultsShareButton />
          </div>
          <RecommendationList
            areResultsOwnedByUser={areResultsOwnedByUser}
            noResultsText="favorite"
          />
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state, props) {
  const { match: { params: { resultUUID } } } = props;
  return {
    resultUUID,
    areResultsOwnedByUser: areResultsOwnedByUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getFilteredRecommendations: actions.getFilteredRecommendations.bind(
        null,
        REC_FILTERS
      ),
      setResult: actions.setResult,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsFavorites);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsFavorites.js